import { LegacyIIQApi } from '../legacy-iiq-api'

export const clearRedisCache =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  () =>
    api.delete(`/cache/redis`)
